/*
*@Author:zhangzhitao
* @Date:2018-12-19
* @Des:重构
* @Last modified by zhangzhitao
*/
<template>
  <div class="home-config-ct">
    <!-- 工具栏，包括：固定工具栏，模式选择，部件拖拉 -->
    <div
      class="m-tool-bar-outer"
      :class="{ 'is-open': toolBarSwitch || toolLock }"
      @mouseover="showToolBar"
      @mouseout="hideToolBar"
    >
      <div class="m-tool-bar-inner">
        <ul class="m-tool-top-wrap">
          <li class="draw-tool-btn">
            <div
              class="u-btn"
              @click="_handleApply"
            >
              <i class="iconfont iconb_ic_save"></i>
              <span>{{ $t("management.home.apply_label") }}</span>
            </div>
          </li>
          <li
            class="draw-tool-btn"
            v-show="drawModel==='full'"
          >
            <div
              class="u-btn"
              @click="handleSave"
            >
              <i class="iconfont iconb_ic_savefuzhi"></i>
              <span>{{ $t("management.home.save") }}</span>
            </div>
          </li>
          <li
            class="draw-tool-btn"
            v-show="drawModel==='full'"
          >
            <div
              class="u-btn"
              @click="handleSaveAs"
            >
              <i class="iconfont iconb_ic_lcwmb"></i>
              <span>{{ $t("management.home.other_save") }}</span>
            </div>
          </li>
          <li class="draw-tool-btn">
            <div
              class="u-btn"
              @click="handleClear"
            >
              <i class="iconfont iconb_ic_trash"></i>
              <span>{{ $t("management.home.claer_board") }}</span>
            </div>
          </li>
          <li
            class="select-mode-btn"
            @click="modelDialog = !modelDialog"
          >
            <div class="u-model-btn">
              <i class="iconfont iconb_ic_ggzs"></i>
              <span>{{ $t("management.home.draw_model") }}</span>
            </div>
            <div
              class="m-mode-drapdown"
              v-show="modelDialog"
            >
              <div
                class="u-column"
                @click="handleChangeDrawModel('full')"
              >
                {{ $t("management.home.full_type") }}
              </div>
              <div
                class="u-column"
                @click="handleChangeDrawModel('limit')"
              >
                {{ $t("management.home.limit_type") }}
              </div>
            </div>
          </li>
          <li
            class="select-mode-btn"
            v-if="drawModel==='limit'"
            @click="widthTypeDialog = !widthTypeDialog"
          >
            <div class="u-model-btn">
              <i class="h-icon-screenshot"></i>
              <span>{{ $t("management.home.width_type") }}</span>
            </div>
            <div
              class="m-mode-drapdown"
              v-show="widthTypeDialog"
            >
              <div
                class="u-column"
                @click="handleChangeWidthType(1)"
              >
                {{ $t("management.home.jx_model") }}
              </div>
              <div
                class="u-column"
                @click="handleChangeWidthType(0)"
              >
                {{ $t("management.home.ls_model") }}
              </div>
            </div>
          </li>
          <li
            class="lock-tool-btn"
            @click="toolLock = !toolLock"
          >
            <i
              class="iconfont iconb_ic_guding"
              v-if="toolLock"
            ></i>
            <i
              class="iconfont iconcommon_guding_f"
              v-else
            ></i>
            <span v-if="toolLock">{{
              $t("management.home.unfixed_operation_bar")
              }}</span>
            <span v-else>{{ $t("management.home.fixed_operation_bar") }}</span>
          </li>
        </ul>
        <div class="m-tool-bottom-wrap">
          <div class="m-tool-top">
            <div class="m-type-tag">
              <span
                :class="{ 'select-type-tag': typeTag === 'widget' }"
                @click="handleTypeTag('widget')"
              >{{ $t("management.home.widget_label") }}</span>
              <span
                :class="{ 'select-type-tag': typeTag === 'model' }"
                v-if="drawModel==='full'"
                @click="handleTypeTag('model')"
              >{{ $t("management.home.moudle_label") }}</span>
            </div>
            <div
              class="m-widget-classify"
              v-show="typeTag === 'widget'&&drawModel==='full'"
            >
              <span
                v-for="item in widgetClassify"
                :class="{ 'is-active': activeWidgetClassify === item.code }"
                @click="handleWidgetClassify(item.code)"
                :key="item.code"
              >{{ item.name }}</span>
            </div>
          </div>
          <div class="m-tool-container">
            <div
              class="m-tool-turn"
              @click="goLeft"
              :class="{
                'disabled-left':
                  disabledDir === 'left' || disabledDir === 'all',
                'm-tool-prev': disabledDir !== 'left' && disabledDir !== 'all'
              }"
            ></div>
            <div class="m-widget-bar">
              <el-scrollbar
                wrap-class="m-scrollbar-wrap"
                view-class="m-scroll-view"
                ref="compsScroll"
                @on-scrolling-x="handleLogScroll"
                tag="ul"
              >
                <span v-if="drawModel==='full'">
                  <li
                    class="m-widget-card"
                    :title="item.name"
                    :key="item.id"
                    :class="[
                    item.type,
                    item.subType,
                    { template: typeTag === 'model' },
                    { waterfall:drawModel==='full'  }
                  ]"
                    v-for="(item, i) in realComps"
                  >
                    <div
                      class="m-widget-cover"
                      @mousedown="dragIn(i, $event, item)"
                    ></div>
                    <div class="m-widget-head">
                      {{ item.name }}
                    </div>
                    <i
                      class="u-utils u-utils-eye1"
                      v-if="typeTag === 'widget'"
                      @mousedown.stop
                      @click.stop="
                      dialogPreview = true;
                      previewWidget = item;
                    "
                    ></i>
                    <i
                      class="u-utils h-icon-delete"
                      v-if="typeTag === 'model'"
                      @mousedown.stop
                      @click.stop="handleDeleteModel(item.id)"
                    ></i>
                  </li>
                </span>
                <span v-else>
                  <li
                    class="m-widget-card"
                    :title="item.name"
                    :key="item.id"
                    :class="{'water-fall':!item.previewImage}"
                    :style="`background:url(${item.previewImage||defaltWaterPic}) center 35px no-repeat`"
                    v-for="(item, i) in realComps"
                  >
                    <div
                      class="m-widget-cover"
                      @mousedown="dragIn(i, $event, item)"
                    ></div>
                    <div class="m-widget-head">
                      {{ item.name }}
                    </div>
                  </li>
                </span>
                <li
                  class="m-seize-seat"
                  :class="{ 'no-data': realComps.length === 0 }"
                  :style="`width:${seizeSeatWidth}px;`"
                >
                  <span v-if="realComps.length === 0">{{
                    typeTag === "widget"
                    ? $t("management.home.no_widgets")
                    : $t("management.home.no_modules")
                    }}</span>
                </li>
              </el-scrollbar>
            </div>
            <!-- <waterfall-card-wrap></waterfall-card-wrap> -->
            <div
              class="m-tool-turn"
              :class="{
                'disabled-right':
                  disabledDir === 'right' || disabledDir === 'all',
                'm-tool-next': disabledDir !== 'right' && disabledDir !== 'all'
              }"
              @click="goRight"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="m-widget-card m-temp-card"
      v-if="tempWidget&&drawModel==='full'"
      :class="[
        activeWidgetType.type,
        activeWidgetType.subType,
        { template: templetStyle },
      ]"
      :style="`left:${tempWidgetPos.left}px;top:${tempWidgetPos.top}px`"
    ></div>
    <div
      class="m-widget-card m-temp-card"
      v-if="tempWidget&&drawModel==='limit'"
      :style="`left:${tempWidgetPos.left}px;top:${tempWidgetPos.top}px;background:url(${tempWidgetPos.previewImage}) no-repeat center`"
    ></div>
    <!-- 编辑区域 -->
    <div
      class="m-draw-board"
      id="board"
    >
      <div
        class="m-draw-container"
        ref="drawCtn"
        @click="activePartsIndex = -1"
        :class="{ 'm-limit-container': drawModel === 'limit','media-container':widthType===1}"
      >
        <template v-if="drawModel === 'full'">
          <div
            class="m-parts-card"
            v-for="(part, index) in arrParts"
            :key="index"
            :class="{ 'u-parts-sel': activePartsIndex === index }"
            :style="
              `width:${part.width}px;height:${part.height}px;left:${
                part.xPos
              }px;top:${part.yPos}px;`
            "
          >
            <div
              class="m-parts-cover"
              @mousemove="drag(index, $event, part)"
              @mouseout="initCursor($event)"
              @click.stop
            ></div>
            <div :style="
                `width:100%;height:100%;box-sizing:border-box;${
                  part.marginStyle
                };${part.borderStyle}`
              ">
              <div
                class="u-parts-head"
                v-show="part.showTitleBar"
                :style="part.titleBarStyle"
              >
                {{ part.title }}
                <span
                  class="u-more"
                  v-if="part.showMore"
                >{{ $t("management.home.more_label") }}></span>
              </div>
              <div
                class="u-widget"
                :class="{ 'u-widget-showbar': part.showTitleBar }"
              >
                <widget-homepage
                  :comType="part.type"
                  :isConfig="true"
                  :comSubType="part.subType"
                  :widgetId="part.id"
                  :url="part.fullUrl"
                  ref="widgetRef"
                ></widget-homepage>
              </div>
            </div>
          </div>
        </template>

        <el-scrollbar
          wrap-class="m-scroll-wrap"
          ref="drawScroll"
          @on-scrolling-y="handleDrawScrollChange"
          v-if="drawModel === 'limit'"
        >
          <div class="m-retractable-wrap">
            <farend-container
              v-for="(part,index) in farEndParts"
              ref="farendCtn"
              :key="index"
              :index="index"
              :part="part"
              :farEndPartsLength="farEndPartsLength"
              @order="handleOrder"
              @remove="handleRemove"
            ></farend-container>
          </div>
        </el-scrollbar>
      </div>
      <canvas
        id="myCanvas"
        class="m-lattice"
        style="width:100%;height:100%;background:#fff;"
      ></canvas>
    </div>
    <!-- 配置栏 -->
    <div
      class="m-config-wrap"
      v-if="this.drawModel==='full'"
      v-show="activePartsIndex !== -1 && arrParts.length > 0"
      :class="{
        'is-right': configPos || drawModel === 'limit',
        'is-left': !configPos && drawModel !== 'limit',
        'is-full': !toolLock,
        'close-config-box': !showConfigBox
      }"
    >
      <div
        class="m-config-btn"
        @click="showConfigBox = !showConfigBox"
      ></div>
      <el-scrollbar wrap-class="m-scroll-wrap">
        <el-form
          label-position="right"
          ref="form"
          class="m-config-form"
          :model="form"
          label-width="120px"
        >
          <el-form-item :label="$t('management.home.widget_size')">
            <div
              class="m-config-size"
              style="margin-right:20px"
            >
              <input
                type="number"
                :disabled="!!form.isBanner"
                class="u-ipt"
                :class="{ 'u-disabled': !!form.isBanner }"
                v-model.number="form.width"
              />
              <span>{{ $t("management.home.width") }}({{
                drawModel === "full" ? "%" : "px"
                }})</span>
            </div>
            <div class="m-config-size">
              <input
                type="number"
                class="u-ipt"
                max="100"
                v-model.number="form.height"
              />
              <span>{{ $t("management.home.height") }}({{
                drawModel === "full" ? "%" : "px"
                }})</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('management.home.pos')">
            <div
              class="m-config-size"
              style="margin-right:20px"
            >
              <input
                type="number"
                class="u-ipt"
                :disabled="!!form.isBanner"
                v-model.number="form.xPos"
              />
              <span>left({{ drawModel === "full" ? "%" : "px" }})</span>
            </div>
            <div class="m-config-size">
              <input
                type="number"
                class="u-ipt"
                v-model.number="form.yPos"
              />
              <span>top({{ drawModel === "full" ? "%" : "px" }})</span>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('management.home.is_banner')"
            v-if="drawModel === 'limit'"
          >
            <el-switch
              v-model="form.isBanner"
              :active-text="$t('common.active_text')"
              :inactive-text="$t('common.inactive_text')"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="$t('management.home.show_title')">
            <el-switch
              v-model="form.showTitleBar"
              :active-text="$t('common.active_text')"
              :inactive-text="$t('common.inactive_text')"
              :disabled="form.type === 'navigation'"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="$t('management.home.title_ctx')">
            <el-input
              v-model="form.title"
              :disabled="!form.showTitleBar"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('management.home.title_style')">
            <el-input
              v-model="form.titleBarStyle"
              :disabled="!form.showTitleBar"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('management.home.title_border_style')">
            <el-input v-model="form.borderStyle"></el-input>
          </el-form-item>
          <el-form-item :label="$t('management.home.title_margin_style')">
            <el-input v-model="form.marginStyle"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('management.widgetInfo.show_more_label')"
            prop="showMore"
          >
            <el-switch
              v-model="form.showMore"
              :active-text="$t('common.active_text')"
              :inactive-text="$t('common.inactive_text')"
              :disabled="!form.showTitleBar"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="$t('management.home.more_open')">
            <el-select
              v-model="form.moreOpenType"
              :disabled="!form.showMore"
              :placeholder="
                $t('management.widgetInfo.more_open_type_placeholder')
              "
            >
              <el-option
                value="dialog"
                :label="$t('management.widgetInfo.more_open_type1')"
              ></el-option>
              <el-option
                value="frame"
                :label="$t('management.widgetInfo.more_open_type2')"
              ></el-option>
              <el-option
                value="newTab"
                :label="$t('management.widgetInfo.more_open_type3')"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('management.home.more_full_url')">
            <el-input
              v-model="form.moreUrl"
              :disabled="!form.showMore"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('management.home.oprate')">
            <el-button
              type="iconButton"
              icon="h-icon-delete"
              @click="delParts"
              :title="$t('management.home.remove_widget')"
            ></el-button>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </div>
    <!-- 预览对话框 -->
    <el-dialog
      :title="$t('management.home.preview_label')"
      :area="[1100, 644]"
      :visible.sync="dialogPreview"
    >
      <div style="width:100%;height:500px;">
        <widget-homepage
          :comType="previewWidget.type"
          :url="previewWidget.fullUrl"
          :preview="true"
          :isConfig="true"
          :comSubType="previewWidget.subType"
          :widgetId="previewWidget.id"
        ></widget-homepage>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogPreview = false">{{
          $t("management.home.close_label")
          }}</el-button>
      </span>
    </el-dialog>
    <!-- 保存对话框 -->
    <el-dialog
      :title="$t('management.home.save_new_label')"
      :visible.sync="dialogSaveShow"
      top="middle"
      :area="400"
    >
      <el-form
        :model="templetInfo"
        :rules="templetInfoRules"
        ref="templetInfo"
      >
        <el-form-item
          :label="$t('management.home.mould_name_label')"
          label-width="80px"
          prop="schemaName"
        >
          <el-input
            v-model="templetInfo.schemaName"
            @change="dupName = false"
          ></el-input>
          <span
            style="color:red; font-size:12px;"
            v-if="dupName"
          >{{
            $t("management.home.dup_name_label")
            }}</span>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="_handleSaveNew"
        >{{
          $t("management.home.sure_label")
          }}</el-button>
        <el-button @click="
            dialogSaveShow = false;
            dupName = false;
          ">{{ $t("management.home.cancel_label") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from 'api/api'
import widgetHomepage from 'components/widget-homepage/widget-homepage.vue'
import farendContainer from './waterfall-pattern/farend-container'
import defaltWaterPic from '../../../assets/images/default_no_image.png'
// import waterfallCardWrap from './waterfall-pattern/waterfall-card-wrap'
import { requireRule, charRule, max32ChartRule } from 'utils/validator'
// import http from 'api/index'
import axios from 'axios'

export default {
  data () {
    return {
      defaltWaterPic: defaltWaterPic,
      // 瀑布风格0:100% ，1教学-媒体查询
      widthType: 1,
      // 用于拖拽时，远端加载部件临时
      tempFarPartStyle: false,
      // ------
      // 管理部件栏显隐
      toolBarSwitch: false,
      // 是否锁定工具栏
      toolLock: true,
      // 画板模式：全屏/限制
      drawModel: 'full',
      // 模板选择窗显隐
      modelDialog: false,
      // 瀑布模式宽度样式
      widthTypeDialog: false,
      // 部件/模板
      typeTag: 'widget',
      // 部件分类
      widgetClassify: [
        { code: 'all', name: this.$t('management.home.nav_all_label') },
        { code: 'navigation', name: this.$t('management.home.nav_nav_label') },
        { code: 'chart', name: this.$t('management.home.nav_charts_label') },
        { code: 'image', name: this.$t('management.home.nav_carousel_label') },
        { code: 'page', name: this.$t('management.home.nav_inset_label') },
        { code: 'table', name: this.$t('management.home.nav_list_label') },
        { code: 'todo', name: this.$t('common.widget_type7') }
      ],
      // 当前选中的部件类型
      activeWidgetClassify: 'all',
      // 是否到头
      disabledDir: 'left',
      // 部件/模板(toolBar中使用)
      arrComps: [],
      // 部件list
      widgets: [],
      // 模板list
      models: [],
      // 当前预览的部件
      previewWidget: {},
      // 部件预览dialog
      dialogPreview: false,
      // 编辑区内的部件
      arrParts: [],
      // 当前被选中的部件，类型及子类型
      activeWidgetType: {
        isShow: false,
        type: '',
        subType: ''
      },
      // 控制临时部件显隐
      tempWidget: false,
      tempWidgetPos: {
        left: 0,
        top: 0
      },
      // 可是窗大小
      winSize: {
        w: 0,
        h: 0
      },
      // 单元格大小
      cell: 0,
      // 当前正在调整的部件index
      activePartsIndex: -1,
      // 配置栏的位置，true表示在右侧，false表示左侧
      configPos: true,
      // 配置栏的开关
      showConfigBox: true,
      // 部件配置表单
      form: {
        width: '',
        height: '',
        xPos: '',
        yPos: '',
        moreOpenType: ''
      },
      // 部件list的滚动条
      compsScroll: {
        scrollLeft: 0
      },
      // 限制模式下，scroll的滚动距离
      drawScrollY: 0,
      // 限制模式下，主容器高度
      // limitCtnH: 0,
      // 模板信息
      templetInfo: {
        schemaWidgetInformation: [],
        schemaName: '',
        schemaId: '',
        layoutType: 0
      },
      templetInfoRules: {
        schemaName: [requireRule, charRule, max32ChartRule]
      },
      // 另存为窗口
      dialogSaveShow: false,
      // 验证模板名称是否重复
      dupName: false,
      // 拖拽模板时，控制临时示例样式展示为模板的样式
      templetStyle: false,
      // 画布内的远端加载部件
      farEndParts: [],
      // 当前选中的远端小部件
      activeFarEndPart: null,
      // 当前选中的远端小部件高度
      activeFarEndPartH: 0,
      activeFarEndIndex: -1,
      // 将要insert的位置
      insertIndex: -1
    }
  },
  components: { widgetHomepage, farendContainer },
  watch: {
    realComps () {
      this.$refs.compsScroll.update()
    },
    activePartsIndex (val) {
      if (val !== -1) {
        this.handleSyncWidgetFromDraw()
      }
    },
    form: {
      handler () {
        if (this.drawModel === 'limit') {
          if (!this.form['isBanner']) {
            this.form['width'] = this.form.width > 1200 ? 1200 : this.form.width
            this.form['xPos'] = this.form.xPos < 0 ? 0 : (this.form.xPos + parseFloat(this.form.width)) > 1200 ? 1200 - this.form.width : this.form.xPos
          }
          this.form['yPos'] = this.form.yPos < 0 ? 0 : this.form.yPos
        } else {
          this.form['xPos'] = this.form.xPos < 0 ? 0 : (this.form.xPos + parseFloat(this.form.width)) > 100 ? 100 - this.form.width : this.form.xPos
          this.form['yPos'] = this.form.yPos < 0 ? 0 : (this.form.yPos + parseFloat(this.form.height)) > 100 ? 100 - this.form.height : this.form.yPos
        }

        this.$nextTick(() => {
          this.handleSyncWidgetFromConfig()
          this.judgeConfigPos(this.activePartsIndex)
        })
      },
      deep: true
    },
    // 'form.xPos' () {
    //   if (this.drawModel === 'full') {
    //     debugger
    //   }
    // },
    'form.width' () {
      if (this.drawModel === 'full') {
        if (this.form.width > 100) {
          this.$set(this.form, 'width', 100)
        }
      } else {
        if (!this.form['isBanner']) {
          if (this.form.width > 1200) {
            this.$set(this.form, 'width', 1200)
          }
        }
      }
    },
    'form.height' () {
      if (this.drawModel === 'full') {
        if (this.form.height > 100) {
          this.$set(this.form, 'height', 100)
        }
      } else {
        if (this.form.height > 3000) {
          this.$set(this.form, 'height', 3000)
        }
      }
    },
    // 切换部件类别时，判断是否可向左向右滑动
    activeWidgetClassify () {
      this.disabledDir = (this.arrComps.length * 172 < this.winSize.w - 116) ? 'all' : 'left'
    },
    drawModel (val) {
      this.$refs.compsScroll.update()
      this.disabledDir = (this.arrComps.length * 172 < this.winSize.w - 116) ? 'all' : 'left'
      if (this.drawModel === 'full') {
        this.getWidgetOrMould()
      } else {
        // 获取瀑布部件
        this.getWaterfallList()
      }
      this.getLayoutSchema(this.drawModel)
    },
    // 模板和部件切换时
    typeTag () {
      this.$refs.compsScroll.update()
      this.$refs.compsScroll.setScroll(-1, 0)
      this.disabledDir = (this.arrComps.length * 172 < this.winSize.w - 116) ? 'all' : 'left'
    }
  },
  created () {
    this.getCurrentLayoutType()
    window.addEventListener('keydown', event => {
      if (event.keyCode === 46 && this.activePartsIndex !== -1) {
        this.delParts()
      }
    })
  },
  computed: {
    // 部件导航卡占位元素的宽度
    seizeSeatWidth () {
      let w = this.winSize.w - 116
      let n = Math.floor(w / 172)
      let y = this.realComps.length % n
      y = y === 0 ? n : y
      let supp = w - 172 * y - 12
      return supp
    },
    realComps () {
      let tempArr = JSON.parse(JSON.stringify(this.arrComps))
      if (this.drawModel === 'full' && this.typeTag === 'widget') {
        let realComps = []
        tempArr.forEach(item => {
          if (item.type === this.activeWidgetClassify || this.activeWidgetClassify === 'all') {
            realComps.push(item)
          }
        })
        return realComps
      } else {
        return tempArr
      }
    },
    arrPartsLength () {
      return this.arrParts.length
    },
    farEndPartsLength () {
      return this.farEndParts.length
    }
  },
  mounted () {
    // 初始化画板
    this.drawLattice()
    window.onresize = temp => {
      this.drawLattice()
    }
    // this.getLayoutSchema('')
  },
  methods: {
    getWidgetOrMould () {
      // 获取小部件
      this.getWidgetList()
      // 获取模板
      this.getMouldList()
    },
    // 获取瀑布小部件
    getWaterfallList () {
      API.homeConfig.getWaterfallList().then(res => {
        this.arrComps = []
        res.data.forEach(comps => {
          if (comps.widgetList && comps.widgetList.length > 0) {
            comps.widgetList.forEach(comp => {
              this.arrComps.push(comp)
            })
          }
        })
      })
    },
    // 瀑布排序
    handleOrder (arrow, part, index) {
      if (arrow === 'up') {
        let temp = this.farEndParts[index - 1]
        this.$set(this.farEndParts, index - 1, part)
        this.$set(this.farEndParts, index, temp)
      } else if (arrow === 'down') {
        let temp = this.farEndParts[index + 1]
        this.$set(this.farEndParts, index + 1, part)
        this.$set(this.farEndParts, index, temp)
      }
    },
    handleRemove (index) {
      this.farEndParts.splice(index, 1)
    },
    // -----------------分割线
    sortObj (array, key) {
      return array.sort(function (a, b) {
        let x = a[key]
        let y = b[key]
        return x - y
      })
    },
    // 获取当前首页类型
    getCurrentLayoutType () {
      API.homeConfig.getCurrentLayoutType().then(res => {
        this.drawModel = res.data ? 'limit' : 'full'
        if (this.drawModel === 'full') {
          this.getWidgetOrMould()
          this.getLayoutSchema('full')
        }
        //  else {
        //   // 获取瀑布部件
        //   this.getWaterfallList()
        // }
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 初始化编辑画板
    drawLattice () {
      let app = document.getElementById('app')
      this.winSize.w = app.offsetWidth
      this.winSize.h = app.offsetHeight
      this.cell = this.winSize.w / 200
      let canvas = document.getElementById('myCanvas')
      canvas.width = this.winSize.w
      canvas.height = this.winSize.h
      let ctx = canvas.getContext('2d')
      ctx.lineWidth = 1
      ctx.strokeStyle = 'rgba(0,0,0,0.05)'
      for (let i = 0; i < 200; i++) {
        ctx.beginPath()
        ctx.moveTo(parseInt(this.cell * i) + 0.5, 0)
        ctx.lineTo(parseInt(this.cell * i) + 0.5, this.winSize.h)
        ctx.stroke()
      }
      for (let j = 0; j < this.winSize.h / this.cell; j++) {
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(0, parseInt(this.cell * j) + 0.5)
        ctx.lineTo(this.winSize.w, parseInt(this.cell * j) + 0.5)
        ctx.stroke()
      }
    },
    // 画板模式
    handleChangeDrawModel (command) {
      if (this.drawModel !== command) {
        if (this.arrParts.length > 0) {
          this.$confirm(
            this.$t('management.home.conf_prompt_content1'),
            {
              confirmButtonText: this.$t('management.home.sure_label'),
              cancelButtonText: this.$t('management.home.cancel_label'),
              type: 'question'
            }
          )
            .then(() => {
              this.arrParts = []
              this.drawModel = command
            })
        } else {
          this.drawModel = command
        }
      }
    },
    // 瀑布风格切换
    handleChangeWidthType (command) {
      this.widthType = command
    },
    judgeConfigPos (index) {
      if (this.arrParts[index].xPos < 380) {
        this.configPos = true
      } else if (this.arrParts[index].xPos > 380 && (this.winSize.w - (this.arrParts[index].xPos + this.arrParts[index].width)) < 380) {
        this.configPos = false
      }
    },
    // 是否锁定工具栏
    showToolBar () {
      if (!this.toolLock) {
        this.toolBarSwitch = true
      }
    },
    hideToolBar () {
      if (!this.toolLock) {
        this.toolBarSwitch = false
      }
    },
    // 部件/模板切换
    handleTypeTag (type) {
      if (this.drawModel === 'full') {
        if (type) {
          this.typeTag = type
        }
        if (this.typeTag === 'widget') {
          this.arrComps = JSON.parse(JSON.stringify(this.widgets))
        } else if (this.typeTag === 'model') {
          this.arrComps = JSON.parse(JSON.stringify(this.models))
          this.activeWidgetClassify = 'all'
        }
      }
    },
    // 部件类型选择
    handleWidgetClassify (code) {
      this.activeWidgetClassify = code
    },
    // 获取部件列表
    getWidgetList () {
      API.homeConfig.widgetList().then(res => {
        this.widgets = res.data.list || []
        this.arrComps = res.data.list || []
        this.disabledDir = (this.arrComps.length * 172 < this.winSize.w - 116) ? 'all' : 'left'
        this.$refs.compsScroll.update()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 获取模板列表
    getMouldList () {
      API.homeConfig.schemaWidgetList({ type: 0 }).then(res => {
        this.models = res.data.list || []
        this.$refs.compsScroll.update()
        this.handleTypeTag()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 记录小部件列表滚动条位置
    handleLogScroll (scroll) {
      this.disabledDir = scroll.percentX === 0 ? 'left' : scroll.percentX === 1 ? 'right' : 'none'
    },
    // 记录编辑区limit模式下滚动条位置
    handleDrawScrollChange (scroll) {
      this.drawScrollY = scroll.scrollTop
    },
    goLeft () {
      let comScroll = document.getElementsByClassName('m-widget-bar')[0].getElementsByClassName('m-scrollbar-wrap')[0]
      let w = this.winSize.w - 116
      let n = Math.floor(w / 172)
      let passW = n * 172
      if (this.disabledDir !== 'left' && this.disabledDir !== 'all') {
        comScroll.scrollLeft = comScroll.scrollLeft - passW
      }
    },
    goRight () {
      let comScroll = document.getElementsByClassName('m-widget-bar')[0].getElementsByClassName('m-scrollbar-wrap')[0]
      let w = this.winSize.w - 116
      let n = Math.floor(w / 172)
      let passW = n * 172
      if (this.disabledDir !== 'right' && this.disabledDir !== 'all') {
        comScroll.scrollLeft = comScroll.scrollLeft + passW
      }
    },
    // 拖拽部件/模板进入画板
    dragIn (index, e, widget) {
      // 当前选的是什么部件
      if (widget.type && this.drawModel === 'full') {
        this.activeWidgetType = {
          type: widget.type,
          subType: widget.subType
        }
        this.templetStyle = false
      } else {
        this.templetStyle = true
      }
      // 临时部件示例图显示
      this.tempWidget = true
      // 获取鼠标位置
      let l = e.clientX - 80
      let t = e.clientY - 55
      // 给临时部件调整位置至鼠标当前位置
      this.tempWidgetPos = {
        left: l,
        top: t
      }
      if (widget.previewImage) {
        this.tempWidgetPos['previewImage'] = widget.previewImage
      }
      // 给临时部件调整位置至鼠标当前位置
      document.onmousemove = e => {
        let l = e.clientX - 80
        let t = e.clientY - 55
        this.tempWidgetPos['left'] = l
        this.tempWidgetPos['top'] = t
      }
      document.onmouseup = e => {
        // 鼠标松开的时候，让临时部件消失，插入实际部件数据
        this.tempWidget = false
        let pos = {}
        if (this.drawModel === 'full') {
          let l = e.clientX - 80
          let t = e.clientY - 55
          pos = {
            xPos: this.handleTrimPosSize(l),
            yPos: this.handleTrimPosSize(t)
          }
          this.handleSyncWidgetFromDraw()
        }
        if (this.toolLock && e.clientY > 300) {
          // 判断是模板还是小部件
          if (!widget.type && this.drawModel === 'full') {
            this._getTempletInfo(widget)
          } else {
            this.handlePushWidget(widget, pos)
          }
        } else if (!this.toolLock) {
          // 判断是模板还是小部件
          if (!widget.type && this.drawModel === 'full') {
            this._getTempletInfo(widget)
          } else {
            this.handlePushWidget(widget, pos)
          }
        }
        document.onmousemove = null // 释放全局捕获
        document.onmouseup = null
        document.onmousedown = null
      }
    },
    // 加载拖拽进入的模板小部件
    _getTempletInfo (templetInfo) {
      this.$confirm(
        this.$t('management.home.conf_prompt_content2'),
        {
          confirmButtonText: this.$t('management.home.sure_label'),
          cancelButtonText: this.$t('management.home.cancel_label'),
          type: 'question'
        }
      ).then(() => {
        this.templetInfo.schemaName = templetInfo.name
        this.templetInfo.schemaId = templetInfo.id
        API.homeConfig.schemaWidgetInfo({ schemaId: templetInfo.id }).then(res => {
          this.drawModel = res.data.layoutType ? 'limit' : 'full'
          this.templetInfo.schemaWidgetInformation = res.data.list || []
          this.handleCompsFromTemplet(res.data.list)
          this.activePartsIndex = -1
        }).catch(err => {
          this.$message.error(err.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('management.home.msg_remove_cancel')
        })
      })
    },
    // 处理模板中的小部件，主要切换full/limit模式中的部件大小及位置
    async handleCompsFromTemplet (parts) {
      this.arrParts = []
      this.farEndParts = []
      if (this.drawModel === 'limit') {
        // parts.forEach(async part => {
        //   let Fn = Function
        //   let res = await axios.get(part.url)
        //   let mode = new Fn(`return ${res.data}`)()
        //   part['mode'] = mode.__esModule ? mode.default : mode
        //   await this.farEndParts.push(part)
        // })
        for (let i = 0; i < parts.length; i++) {
          await this.handleFarEndParts(parts[i])
        }
      } else {
        parts.forEach(item => {
          let temp = JSON.parse(JSON.stringify(item))
          temp.width = temp.width * this.winSize.w / 100
          temp.height = temp.height * this.winSize.h / 100
          temp.xPos = temp.xPos * this.winSize.w / 100
          temp.yPos = temp.yPos * this.winSize.h / 100
          this.arrParts.push(temp)
        })
      }
    },
    handleFarEndParts (widget) {
      return new Promise(async (resolve, reject) => {
        let part = JSON.parse(JSON.stringify(widget))
        let Fn = Function
        let res = await axios.get(part.url)
        let mode = new Fn(`return ${res.data}`)()
        part['mode'] = mode.__esModule ? mode.default : mode
        this.farEndParts.push(part)
        resolve()
      })
    },
    // 将拖拽的部件数据置入编辑区内
    async handlePushWidget (widget, pos) {
      if (this.drawModel === 'full') {
        if (widget.type === 'navigation') {
          let tempArr = []
          this.arrParts.forEach(item => {
            if (item.type === 'navigation') {
              tempArr.push(item)
            }
          })
          if (tempArr.length > 0) {
            this.$confirm(this.$t('management.home.repeat_nav'), {
              confirmButtonText: this.$t('common.confirmBtn_text'),
              cancelButtonText: this.$t('common.cancelBtn_text'),
              type: 'question'
            }).then(() => {
              this.pushWidget(widget, pos)
            })
          } else {
            this.pushWidget(widget, pos)
          }
        } else {
          this.pushWidget(widget, pos)
        }
      } else {
        let checkString = JSON.stringify(this.farEndParts)
        if (checkString.indexOf(widget.id) >= 0) {
          this.$message.error('瀑布模式下部件不能重复添加')
          return
        }
        let part = JSON.parse(JSON.stringify(widget))
        let Fn = Function
        let res = await axios.get(part.url)
        let mode = new Fn(`return ${res.data}`)()
        part['mode'] = mode.__esModule ? mode.default : mode
        this.farEndParts.push(part)
      }
    },
    pushWidget (widget, pos) {
      let part = JSON.parse(JSON.stringify(widget))
      if (this.drawModel === 'limit') {
        part['xPos'] = pos.xPos < 0 ? 0 : (pos.xPos + widget.width) > 1200 ? 1200 - widget.width : pos.xPos
      } else {
        part['xPos'] = pos.xPos < 0 ? 0 : (pos.xPos + widget.width) > this.winSize.w ? this.winSize.w - widget.width : pos.xPos
      }
      if (this.drawModel === 'full') {
        part['yPos'] = pos.yPos < 0 ? 0 : (pos.yPos + widget.height) > this.winSize.h ? this.winSize.h - widget.height : pos.yPos
      } else {
        part['yPos'] = pos.yPos < 0 ? 0 : pos.yPos
      }
      part['isBanner'] = false
      this.arrParts.push(part)
      this.activePartsIndex = this.arrParts.length - 1
      this.handleSyncWidgetFromDraw()
    },
    // 编辑区域内，调整部件大小及位置
    drag (index, e, widget) {
      let flag = this.judgeNextOperate(e, widget)
      let el = e.target.parentNode
      // 鼠标点中要改变的部件
      el.onmousedown = e => {
        this.activePartsIndex = index
        // 获取鼠标点下时，鼠标的位置
        let startX = e.clientX
        let startY = e.clientY
        // 深拷贝，记录部件初始大小及位置
        let Parts = JSON.parse(JSON.stringify(widget))
        // 鼠标按住不松开，进行移动
        document.onmousemove = e => {
          let midX = e.clientX
          let midY = e.clientY
          // 通过flag判断用户当前操作意图
          if (flag === 'left') {
            let differ = midX - startX
            widget.width = Parts.width - differ
            widget.xPos = Parts.xPos + differ
          } else if (flag === 'right') {
            let differ = midX - startX
            widget.width = Parts.width + differ
          } else if (flag === 'top') {
            let differ = midY - startY
            widget.height = Parts.height - differ
            widget.yPos = Parts.yPos + differ
          } else if (flag === 'bottom') {
            let differ = midY - startY
            widget.height = Parts.height + differ
          } else if (flag === 'bottomRight') {
            let diffX = midX - startX
            let diffY = midY - startY
            widget.width = Parts.width + diffX
            widget.height = Parts.height + diffY
          } else if (flag === 'move') {
            let diffX = midX - startX
            let diffY = midY - startY
            if (!widget.isBanner) {
              widget.xPos = Parts.xPos + diffX
            }
            widget.yPos = Parts.yPos + diffY
          }
          if (Parts.type === 'todo') {
            widget.width = widget.width < 308 ? 308 : widget.width
            // widget.height = widget.height > 325 ? 325 : widget.height
          }
          // 当部件改变大小的时候判断部件是否是charts部件，是的话，初始化其内容
          if (flag !== 'move') {
            this.initCharts(widget, index)
            if (widget.type === 'navigation' && widget.subType === 'full') {
              widget.width = widget.width < 1400 ? 1400 : widget.width
            }
          }
          this.judgeConfigPos(this.activePartsIndex)
          // 鼠标松开，确定部件最终位置
          document.onmouseup = e => {
            let nowParts = JSON.parse(JSON.stringify(widget))
            if (flag === 'left') {
              widget.width = this.handleTrimPosSize(nowParts.width)
            } else if (flag === 'right') {
              widget.width = this.handleTrimPosSize(nowParts.width)
            } else if (flag === 'top') {
              widget.yPos = this.handleTrimPosSize(nowParts.yPos)
            } else if (flag === 'bottom') {
              widget.height = this.handleTrimPosSize(nowParts.height)
            } else if (flag === 'bottomRight') {
              widget.width = this.handleTrimPosSize(nowParts.width)
              widget.height = this.handleTrimPosSize(nowParts.height)
            } else if (flag === 'move') {
              let xTemp = this.handleTrimPosSize(nowParts.xPos)
              let yTemp = this.handleTrimPosSize(nowParts.yPos)
              if (this.drawModel === 'limit') {
                widget.xPos = xTemp < 0 ? 0 : (xTemp + widget.width) > 1200 ? 1200 - widget.width : xTemp
              } else {
                widget.xPos = xTemp < 0 ? 0 : (xTemp + widget.width) > this.winSize.w ? this.winSize.w - widget.width : xTemp
              }
              if (this.drawModel === 'full') {
                widget.yPos = yTemp < 0 ? 0 : (yTemp + widget.height) > this.winSize.h ? this.winSize.h - widget.height : yTemp
              } else {
                widget.yPos = yTemp < 0 ? 0 : yTemp
              }
            }
            if (flag !== 'move') {
              this.initCharts(widget, index)
            }
            this.handleSyncWidgetFromDraw()
            document.onmousemove = null // 释放全局捕获
            document.onmouseup = null
            document.onmousedown = null
          }
        }
        document.onmouseup = e => {
          document.onmousemove = null // 释放全局捕获
          document.onmouseup = null
          document.onmousedown = null
          el.style.cursor = 'default'
        }
      }
    },
    initCharts (obj, index) {
      if (obj.type === 'chart') {
        this.$refs.widgetRef[index].chartsResize()
      } else if (obj.type === 'image') {
        this.$refs.widgetRef[index].imageResize()
      } else if (obj.type === 'navigation' && obj.subType === 'full') {
        this.$refs.widgetRef[index].initCardNav()
      }
    },
    // 按比例/取整数微调
    handleTrimPosSize (val) {
      if (this.drawModel === 'full') {
        return parseInt(val / this.cell) * this.cell
      } else if (this.drawModel === 'limit') {
        return val
      }
    },
    // 编辑区位置调整同步配置栏
    handleSyncWidgetFromDraw () {
      if (this.activePartsIndex !== -1 && this.arrParts.length > 0) {
        if (this.drawModel === 'full') {
          let tempForm = JSON.parse(JSON.stringify(this.arrParts[this.activePartsIndex]))
          this.form = JSON.parse(JSON.stringify(this.arrParts[this.activePartsIndex]))
          this.form.width = (tempForm.width * 100 / this.winSize.w).toFixed(2)
          this.form.height = (tempForm.height * 100 / this.winSize.h).toFixed(2)
          this.form.xPos = (tempForm.xPos * 100 / this.winSize.w).toFixed(2)
          this.form.yPos = (tempForm.yPos * 100 / this.winSize.h).toFixed(2)
        } else if (this.drawModel === 'limit') {
          this.form = JSON.parse(JSON.stringify(this.arrParts[this.activePartsIndex]))
          this.form.isBanner = !!this.form.isBanner
        }
      }
    },
    // 配置栏内信息同步编辑区
    handleSyncWidgetFromConfig () {
      let widget = this.arrParts[this.activePartsIndex]
      let temp = JSON.parse(JSON.stringify(this.form))
      if (this.drawModel === 'full') {
        delete temp.width
        delete temp.height
        delete temp.xPos
        delete temp.yPos
        widget.width = this.form.width * this.winSize.w / 100
        widget.height = this.form.height * this.winSize.h / 100
        widget.xPos = this.form.xPos * this.winSize.w / 100
        widget.yPos = this.form.yPos * this.winSize.h / 100
        widget = Object.assign(widget, temp)
      } else if (this.drawModel === 'limit') {
        widget = Object.assign(widget, temp)
        if (widget.isBanner) {
          widget.width = this.winSize.w
          widget.xPos = -this.$refs.drawCtn.offsetLeft
        }
      }
      this.$nextTick(() => {
        this.initCharts(this.form, this.activePartsIndex)
      })
    },
    // 根据鼠标与部件的相对位置，判断下已不可能的操作
    judgeNextOperate (e, widget) {
      let el = e.target.parentNode
      let clientX = e.clientX
      let clientY = e.clientY
      if (this.drawModel === 'limit') {
        clientX = e.clientX - this.$refs.drawCtn.offsetLeft
        clientY = e.clientY + this.drawScrollY
      }
      let LB = widget.xPos
      let TB = widget.yPos
      let BB = widget.yPos + widget.height
      let RB = widget.xPos + widget.width
      let boundaryWidth = 10
      let res = ''
      if (clientX > RB - boundaryWidth && clientX < RB && clientY < BB && clientY > BB - boundaryWidth && !widget.isBanner) {
        res = 'bottomRight'
        el.style.cursor = 'se-resize'
      } else if (clientX > LB && clientX < LB + boundaryWidth && !widget.isBanner) {
        res = 'left'
        el.style.cursor = 'w-resize'
      } else if (clientX > RB - boundaryWidth && clientX < RB && !widget.isBanner) {
        res = 'right'
        el.style.cursor = 'e-resize'
      } else if (clientY > TB && clientY < TB + boundaryWidth) {
        res = 'top'
        el.style.cursor = 'n-resize'
      } else if (clientY < BB && clientY > BB - boundaryWidth) {
        res = 'bottom'
        el.style.cursor = 's-resize'
      } else if (clientX > LB + boundaryWidth && clientX < RB - boundaryWidth && clientY > TB + boundaryWidth && clientY < BB - boundaryWidth) {
        res = 'move'
        el.style.cursor = 'move'
      } else {
        res = ''
        el.style.cursor = 'default'
      }
      return res
    },
    // 初始化指针
    initCursor (e) {
      let el = e.target.parentNode
      el.style.cursor = 'default'
    },
    // 移除编辑区域内的parts
    delParts () {
      let i = this.activePartsIndex
      this.arrParts.splice(i, 1)
      if (this.arrParts.length > 0) {
        if (i !== 0) {
          this.activePartsIndex = i - 1
        } else {
          this.activePartsIndex = i
        }
      } else {
        this.activePartsIndex = -1
      }
    },
    // 遍历编辑区内的部件
    handleErgodicWidget () {
      let parts = []
      if (this.drawModel === 'full') {
        this.arrParts.forEach(item => {
          let temp = JSON.parse(JSON.stringify(item))
          temp.isBanner = temp.isBanner ? 1 : 0
          temp.width = (temp.width * 100 / this.winSize.w).toFixed(2)
          temp.height = (temp.height * 100 / this.winSize.h).toFixed(2)
          temp.xPos = (temp.xPos * 100 / this.winSize.w).toFixed(2)
          temp.yPos = (temp.yPos * 100 / this.winSize.h).toFixed(2)
          parts.push(temp)
        })
      } else {
        this.farEndParts.forEach(item => {
          let temp = JSON.parse(JSON.stringify(item))
          let params = {
            url: temp.url,
            id: temp.id,
            name: temp.name
          }
          parts.push(params)
        })
      }
      return parts
    },
    // 获取当前首页模板
    getLayoutSchema (type) {
      API.homeConfig
        .userWidget({ isBigData: false, layoutType: type === 'full' ? 0 : 1 })
        .then(res => {
          this.widthType = res.data.widthType
          this.drawModel = res.data.layoutType ? 'limit' : 'full'
          this.handleCompsFromTemplet(res.data.userWidgetInfos)
        }).catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 应用（保存）
    _handleApply () {
      let parts = this.handleErgodicWidget()
      if (parts.length === 0) {
        this.$message.error(this.$t('management.home.index_widget_no'))
        return false
      }
      let params = {
        administrator: true,
        layoutType: this.drawModel === 'full' ? 0 : 1,
        widthType: this.widthType,
        userWidgetInfos: parts
      }
      API.homeConfig
        .apply(params)
        .then(res => {
          this.$message({
            message: this.$t('management.home.msg_apply_success'),
            type: 'success'
          })
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 保存模板
    handleSave () {
      if (this.templetInfo.schemaId !== '') {
        API.homeConfig
          .save({
            schemaWidgetInformation: this.handleErgodicWidget(),
            schemaId: this.templetInfo.schemaId,
            layoutType: this.drawModel === 'full' ? 0 : 1
          })
          .then(res => {
            this.$message({
              message: this.$t('management.home.msg_sava_success'),
              type: 'success'
            })
            this.getMouldList()
          })
          .catch(error => {
            this.$message.error(error.msg)
          })
      } else {
        this.handleSaveAs()
      }
    },
    // 打开另存为模板dialog
    handleSaveAs () {
      this.templetInfo.schemaName = ''
      this.dialogSaveShow = true
    },
    // 删除模板
    handleDeleteModel (id) {
      this.$confirm(
        this.$t('management.home.conf_prompt_content3'),
        {
          confirmButtonText: this.$t('management.home.sure_label'),
          cancelButtonText: this.$t('management.home.cancel_label'),
          type: 'question'
        }
      )
        .then(() => {
          API.homeConfig
            .delMould({ schemaIds: id })
            .then(res => {
              this.getMouldList()
              this.$message({
                message: this.$t('management.home.msg_delete_success'),
                type: 'success'
              })
            })
            .catch(error => {
              this.$message.error(error.msg)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('management.home.msg_remove_cancel')
          })
        })
    },
    // 另存为模板
    _handleSaveNew () {
      this.$refs.templetInfo.validate(valid => {
        if (valid) {
          let parts = JSON.parse(JSON.stringify(this.handleErgodicWidget()))
          API.homeConfig.saveNew({
            schemaWidgetInformation: parts,
            schemaName: this.templetInfo.schemaName,
            layoutType: this.drawModel === 'full' ? 0 : 1
          }).then(res => {
            this.dialogSaveShow = false
            this.getMouldList()
            this.$message.success(this.$t('management.home.msg_sava_success'))
          }).catch(error => {
            if (error.code === '0x18514015') {
              this.dupName = true
            } else {
              this.$message.error(error.msg)
            }
          })
        }
      })
    },
    // 清空
    handleClear () {
      this.$confirm(
        this.$t('management.home.conf_prompt_content2'),
        {
          confirmButtonText: this.$t('management.home.sure_label'),
          cancelButtonText: this.$t('management.home.cancel_label'),
          type: 'question'
        }
      )
        .then(() => {
          if (this.drawModel === 'full') {
            this.arrParts = []
          } else {
            this.farEndParts = []
          }
          this.$message({
            type: 'success',
            message: this.$t('management.home.msg_remove_success')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('management.home.msg_remove_cancel')
          })
        })
    }
  }
}
</script>

<style lang="less"  rel="stylesheet/less">
@import "~assets/styles/wi-font/iconfont.css";

.home-config-ct {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  .m-tool-bar-outer {
    position: absolute;
    left: 0;
    top: -224px;
    width: 100%;
    height: 244px;
    padding-bottom: 20px;
    box-sizing: border-box;
    transition: all 0.3s;
    z-index: 6;
    user-select: none;
    .m-tool-bar-inner {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 16px;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
      .m-tool-top-wrap {
        width: 100%;
        height: 48px;
        list-style: none;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        li {
          position: relative;
          float: left;
          margin-right: 24px;
          height: 48px;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.7);
          cursor: pointer;
          i {
            margin-right: 8px;
            font-size: 16px;
            float: left;
          }
        }
        // li:hover {
        //   color: rgba(0, 0, 0, 0.9);
        // }
        .draw-tool-btn {
          .u-btn {
            height: 32px;
            line-height: 32px;
            padding: 0 8px;
            margin: 8px 0;
            i {
              font-size: 24px;
            }
          }
          .u-btn:hover {
            background: rgba(0, 0, 0, 0.08);
          }
        }
        .select-mode-btn {
          line-height: 48px;
          .m-mode-drapdown {
            position: absolute;
            top: 40px;
            left: 24px;
            background: #fff;
            width: 120px;
            padding: 8px;
            box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
            z-index: 999;
            .u-column {
              width: 100%;
              box-sizing: border-box;
              line-height: 32px;
              padding: 0 10px;
            }
            .u-column:hover {
              background: rgba(0, 0, 0, 0.1);
            }
          }
          .u-model-btn {
            float: left;
            height: 32px;
            line-height: 32px;
            padding: 0 8px;
            margin-top: 8px;
            margin-right: 8px;
            i {
              font-size: 24px;
            }
            .h-icon-screenshot {
              margin-top: 4px;
            }
          }
          .u-model-btn:hover {
            background: rgba(0, 0, 0, 0.08);
          }
        }
        .select-mode-btn::before {
          content: "";
          display: block;
          float: left;
          margin-top: 12px;
          margin-right: 16px;
          width: 1px;
          height: 24px;
          background: rgba(0, 0, 0, 0.12);
        }
        .lock-tool-btn {
          float: right;
          line-height: 48px;
          margin-right: 0;
          i {
            font-size: 24px;
          }
        }
      }
      .m-tool-bottom-wrap {
        width: 100%;
        height: calc(~"100% - 48px");
        .m-tool-top {
          width: 100%;
          padding: 8px 0;
          overflow: hidden;
          .m-type-tag {
            float: left;
            color: #999;
            line-height: 32px;
            font-size: 12px;
            overflow: hidden;
            span {
              display: block;
              float: left;
              width: 96px;
              text-align: center;
              cursor: pointer;
            }
            span:hover {
              color: #4c4c4c;
            }
            .select-type-tag {
              font-weight: bold;
              color: #4c4c4c;
              background: #ebebeb;
            }
          }
          .m-widget-classify {
            float: right;
            color: #999;
            line-height: 32px;
            font-size: 12px;
            span {
              display: block;
              float: left;
              padding: 0 20px;
              text-align: center;
              cursor: pointer;
            }
            span:hover {
              color: #4c4c4c;
            }
            .is-active {
              font-weight: bold;
              color: #4c4c4c;
            }
          }
        }
        .m-tool-container {
          width: 100%;
          height: calc(~"100% - 48px");
          .m-widget-bar {
            float: left;
            width: calc(~"100% - 84px");
            height: 100%;
            .m-scrollbar-wrap {
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              .m-scroll-view {
                padding: 0;
                margin: 0;
                list-style: none;
                white-space: nowrap;
                position: relative;
              }
            }
            /deep/ .is-horizontal {
              display: none;
            }
            /deep/ .el-scrollbar__bar.is-vertical {
              display: none;
            }
          }
          .m-tool-turn {
            float: left;
            width: 26px;
            height: 100%;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
          }
          .m-tool-prev {
            margin-right: 16px;
            background-image: url("../../../assets/images/home-config/btn_left.png");
          }
          .m-tool-prev:hover {
            background-image: url("../../../assets/images/home-config/btn_left_hover.png");
          }
          .m-tool-next {
            margin-left: 16px;
            background-image: url("../../../assets/images/home-config/btn_right.png");
          }
          .m-tool-next:hover {
            background-image: url("../../../assets/images/home-config/btn_right_hover.png");
          }
          .disabled-right {
            margin-left: 16px;
            cursor: not-allowed;
            background-image: url("../../../assets/images/home-config/btn_right_disabled.png");
          }
          .disabled-left {
            margin-right: 16px;
            cursor: not-allowed;
            background-image: url("../../../assets/images/home-config/btn_left_disabled.png");
          }
        }
      }
      .m-tool-left-wrap {
        width: 200px;
        height: 100%;
        float: left;
        box-sizing: border-box;
        padding-right: 10px;
        border-right: 1px solid #e5e5e5;
        .m-tool-top {
          width: 100%;
          height: 70px;
          box-sizing: border-box;
          border-bottom: 1px solid #f5f5f5;
          .u-mode-change {
            width: 50%;
            height: 100%;
            float: left;
            box-sizing: border-box;
            padding-top: 4px;
            text-align: center;
            cursor: pointer;
          }

          .u-lock-tool {
            width: calc(~"50% - 1px");
            height: 100%;
            float: left;
            box-sizing: border-box;
            text-align: center;
            cursor: pointer;
            span {
              display: block;
              width: 100%;
              text-align: center;
              font-size: 12px;
              color: #484c6a;
            }
          }
          .u-lock-tool:before {
            content: "";
            width: 1px;
            height: 60px;
            background: #e5e5e5;
            float: left;
            margin-top: 4px;
          }
        }
        .m-tool-bottom {
          box-sizing: border-box;
          padding: 20px;
          list-style: none;
          font-size: 12px;
          padding: 0;
          margin: 0;
          line-height: 32px;
          li {
            display: block;
            width: calc(~"100% - 20px");
            padding: 0 10px;
            color: #333;
            cursor: pointer;
            .u-icon {
              display: block;
              float: left;
              width: 16px;
              height: 16px;
              margin: 8px 8px 8px 0;
            }
          }
          li:hover {
            background: #f2f2f2;
          }
          li:first-child .u-icon {
            background-image: url("../../../assets/images/home-config/btn_save.png");
          }
          li:nth-child(2) .u-icon {
            background-image: url("../../../assets/images/home-config/btn_collect.png");
          }
          li:nth-child(3) .u-icon {
            background-image: url("../../../assets/images/home-config/btn_del.png");
          }
          li:nth-child(4) .u-icon {
            background-image: url("../../../assets/images/home-config/btn_save.png");
          }
        }
      }
      .m-tool-right-wrap {
        float: right;
        width: calc(~"100% - 210px");
        height: 100%;
      }
    }
  }
  .is-open {
    top: 0px;
  }

  .m-draw-board {
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    right: 0px;
    z-index: 4;
    // background: rgba(0, 0, 0, 0.2);
    .m-draw-container {
      position: absolute;
      left: 0px;
      top: 0px;
      bottom: 0px;
      right: 0px;
      z-index: 4;
      cursor: default;
      .m-parts-card {
        position: absolute;
        box-sizing: border-box;
        border: 1px solid transparent;
        background: #fff;
        z-index: 1;
        .m-parts-cover {
          position: absolute;
          left: 0px;
          top: 0px;
          bottom: 0px;
          right: 0px;
          z-index: 6;
        }
        .u-parts-head {
          width: 100%;
          height: 40px;
          font-size: 14px;
          line-height: 40px;
          text-indent: 10px;
          box-sizing: border-box;
          color: #4c4c4c;
          .u-more {
            float: right;
            margin-right: 10px;
            font-size: 12px;
            color: #7f7f7f;
          }
        }
        .u-widget {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          overflow: hidden;
        }
        .u-widget-showbar {
          height: calc(~"100% - 40px");
        }
        .u-del-parts {
          position: absolute;
          right: -25px;
          top: 0;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 10px;
          color: #fff;
          background: #d8d8d8;
          cursor: pointer !important;
          z-index: -1;
        }
      }

      .m-parts-card.u-parts-sel {
        border-color: #1e7fff;
        z-index: 2;
      }
    }
    .m-draw-container.m-limit-container {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background: rgba(0, 0, 0, 0.1);
      z-index: 4;
      &.media-container {
        width: 1720px;
        @media screen and (max-width: 1760px) and (min-width: 1480px) {
          width: calc(100% - 40px);
        }
        @media screen and (max-width: 1480px) {
          width: 100%;
        }
      }
      .m-scroll-wrap {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        .m-retractable-wrap {
          position: relative;
          width: 100%;
          height: 100%;
          .m-invented {
            position: absolute;
            width: 100%;
            background: rgb(252, 122, 0);
            z-index: 99999;
          }
        }
      }
      .m-parts-card {
        position: absolute;
        box-sizing: border-box;
        border: 1px solid transparent;
        background: #fff;
        z-index: 1;
        user-select: none;
        .m-parts-cover {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 999;
        }
        .u-parts-head {
          width: 100%;
          height: 40px;
          font-size: 14px;
          line-height: 40px;
          text-indent: 10px;
          box-sizing: border-box;
          color: #4c4c4c;
          .u-more {
            float: right;
            margin-right: 10px;
            font-size: 12px;
            color: #7f7f7f;
          }
        }
        .u-widget {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
        }
        .u-widget-showbar {
          height: calc(~"100% - 40px");
        }
        .u-del-parts {
          position: absolute;
          right: -25px;
          top: 0;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 10px;
          color: #fff;
          background: #d8d8d8;
          cursor: pointer !important;
          z-index: -1;
        }
      }
      .m-parts-card.u-parts-sel {
        border-color: #1e7fff;
        z-index: 2;
      }
    }
  }
  .m-widget-card {
    position: relative;
    display: inline-block;
    width: 160px;
    height: 110px !important;
    margin-bottom: 10px;
    margin-right: 12px;
    border-radius: 4px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: move;
    vertical-align: top;
    &.water-fall {
      border: 1px solid #ccc;
    }
    .m-widget-cover {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
    }
    .m-widget-head {
      width: calc(~"100% - 30px");
      box-sizing: border-box;
      padding: 0 20px;
      line-height: 36px;
      color: #4c4c4c;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .u-utils {
      display: block;
      position: absolute;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      top: 4px;
      right: 20px;
      z-index: 3;
      cursor: pointer;
      &.h-icon-delete {
        font-size: 24px;
      }
    }
    .u-utils-eye1 {
      background: url("~assets/images/home-config/btn_show.png") no-repeat
        center;
    }
    .u-utils-eye2 {
      background: url("~assets/images/home-config/btn_show.png") no-repeat
        center;
    }
  }
  .m-widget-card.m-temp-card {
    position: fixed;
    display: block;
    margin: 0;
    z-index: 9999;
  }
  .m-seize-seat {
    display: inline-block;
    width: 0px;
    height: 110px !important;
    margin-bottom: 10px;
    vertical-align: top;
  }
  .m-seize-seat.no-data {
    line-height: 110px;
    position: absolute;
    left: 50%;
    margin-left: -36px;
    font-size: 14px;
    span {
      color: #999;
    }
  }
  .m-config-wrap {
    position: absolute;
    top: 240px;
    width: 360px;
    height: calc(~"100% - 260px");
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    z-index: 5;
    .m-config-btn {
      position: absolute;
      top: 50%;
      margin-top: -48px;
      width: 24px;
      height: 96px;
      background: #fff;
      background-image: url("../../../assets/images/pic_arrow.png");
      background-repeat: no-repeat;
      z-index: 6;
      cursor: pointer;
    }
    .m-scroll-wrap {
      position: absolute;
      left: 0px;
      top: 0px;
      bottom: 0px;
      right: 0px;
      .m-config-size {
        float: left;
        width: 90px;
        height: 64px;
        .u-ipt {
          width: 100%;
          border: 1px solid #ccc;
          box-sizing: border-box;
          border-radius: 2px;
          background-color: #fff;
          background-image: none;
          border-radius: 2px;
          border: 1px solid #ccc;
          color: #333;
          font-size: inherit;
          height: 32px;
          line-height: 1;
          outline: 0;
          padding: 3px 8px;
          font-size: 12px;
          color: rgb(51, 51, 51);
          transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }

        .u-ipt:hover,
        .u-ipt:focus {
          border-color: #666;
        }
        .u-ipt.u-disabled {
          background-color: #f2f2f2;
          border-color: #e5e5e5;
          color: #ccc;
          cursor: not-allowed;
        }
        .u-ipt.u-disabled:hover {
          border-color: #ccc;
        }
        span {
          display: block;
          text-align: center;
          color: #484c6a;
          font-size: 12px;
        }
      }
      .el-form {
        box-sizing: border-box;
        padding: 20px;
      }
    }
  }
  .m-config-wrap.is-right {
    right: 0;
    .m-config-btn {
      left: -24px;
      background-position: -26px center;
      box-shadow: -2px 0 2px rgba(0, 0, 0, 0.1);
    }
  }
  .m-config-wrap.is-right.close-config-box {
    right: -360px;
    .m-config-btn {
      background-position: 4px center;
    }
  }
  .m-config-wrap.is-left {
    left: 0;
    .m-config-btn {
      right: -24px;
      background-position: 4px center;
      box-shadow: 5px 0 5px rgba(0, 0, 0, 0.1);
    }
  }
  .m-config-wrap.is-left.close-config-box {
    left: -360px;
    .m-config-btn {
      background-position: -26px center;
    }
  }
  .m-config-wrap.is-full {
    top: 20px;
    height: calc(~"100% - 40px");
  }
  .navigation {
    background: url("~assets/images/home-config/bg_Home_navigation.png")
      no-repeat center;
  }
  .chart.echarts-line {
    background: url("~assets/images/home-config/bg_line.png") no-repeat center;
  }
  .chart.echarts-bar {
    background: url("~assets/images/home-config/bg_histogram.png") no-repeat
      center;
  }
  .chart.echarts-circle {
    background: url("~assets/images/home-config/bg_pie.png") no-repeat center;
  }
  .table {
    background: url("~assets/images/home-config/bg_list.png") no-repeat center;
  }
  .image {
    background: url("~assets/images/home-config/bg_image carousel.png")
      no-repeat center;
  }
  .page {
    background: url("~assets/images/home-config/bg_embedded.png") no-repeat
      center;
  }
  .template {
    background: url("~assets/images/home-config/bg_template.png") no-repeat
      center;
  }
  .todo {
    background: url("~assets/images/home-config/bg_todo.png") no-repeat center;
  }
}
</style>
